import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Controller, useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { Password } from "primereact/password";
import axios from "axios";
import config from "../config/config";

const Authentication = () => {
	useEffect(() => {
		const isLoggedIn = localStorage.getItem("_PRISTOKEN_");
		if (isLoggedIn) {
			navigate("/beranda", { replace: true });
		}
	}, []);

	const navigate = useNavigate();

	const toast = useRef(null);

	const defaultValues = {
		username: "",
		password: "",
	};

	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm({ defaultValues });

	const onSubmit = async (data) => {
		try {
			const response = await axios.post(
				`${config.BASE_URL}/Account/login`,
				data,
			);

			if (!response.data.result) {
				toast.current.show({
					severity: "warn",
					summary: "Oops",
					detail: response.data.message,
				});
			} else {
				toast.current.show({
					severity: "success",
					summary: "Success",
					detail: response.data.message,
				});

				localStorage.setItem(
					"_PRISTOKEN_",
					response.data.objectValue.token,
				);

				localStorage.setItem(
					"_PRISUID_",
					JSON.stringify(response.data.objectValue.user),
				);

				setTimeout(() => {
					navigate("/beranda", { replace: true });
				}, 1000);
			}
		} catch (error) {
			toast.current.show({
				severity: "error",
				summary: "Oops",
				detail: error.error.message,
			});

			throw error;
		}
	};

	const getFormErrorMessage = (name) => {
		return errors[name] ? (
			<small className="p-error">{errors[name].message}</small>
		) : (
			<small className="p-error">&nbsp;</small>
		);
	};

	return (
		<div className="h-full flex">
			<Toast ref={toast} />

			<div className="flex flex-col gap-1 justify-center w-7/12 p-10">
				<p className="text-3xl font-bold text-blue-500">
					Product Information System
				</p>
				<p className="text-2xl text-gray-700">For Sales Web Based</p>
			</div>

			<div className="flex flex-col w-5/12 p-10 bg-white rounded-l-xl shadow-md justify-center">
				<div className="flex flex-col gap-2">
					<div
						className="flex flex-col gap-2 mb-5"
						style={{ marginBottom: "20px" }}
					>
						<p className="text-3xl font-bold text-gray-800">
							Selamat datang di
							<br></br>
							<span className="text-blue-500">
								Product Information System
							</span>
						</p>
						<p className="text-sm text-gray-600">
							Ketik username dan password untuk masuk ke akun anda
						</p>
					</div>

					<Controller
						name="username"
						control={control}
						rules={{ required: "Username Tidak Boleh Kosong" }}
						render={({ field, fieldState }) => (
							<div className="flex flex-col gap-1">
								<label
									htmlFor={field.name}
									className={classNames({
										"p-error": errors.value,
									})}
								></label>

								<p className="text-gray-600">Username</p>

								<InputText
									id={field.value}
									value={field.username}
									className={classNames({
										"p-invalid": fieldState.error,
										"p-inputtext-sm": true,
									})}
									onChange={(e) =>
										field.onChange(e.target.value)
									}
								/>
								{getFormErrorMessage(field.name)}
							</div>
						)}
					/>

					<Controller
						name="password"
						control={control}
						rules={{ required: "Password Tidak Boleh Kosong" }}
						render={({ field, fieldState }) => (
							<div className="flex flex-col gap-1">
								<label
									htmlFor={field.name}
									className={classNames({
										"p-error": errors.value,
									})}
								></label>

								<p className="text-gray-600">Password</p>

								<Password
									id={field.value}
									value={field.username}
									className={classNames({
										"p-invalid": fieldState.error,
										"w-full": true,
										"p-inputtext-sm": true,
									})}
									onChange={(e) =>
										field.onChange(e.target.value)
									}
									toggleMask
									feedback={false}
								/>

								<p className="text-sm text-gray-600">
									Lupa Password?
								</p>

								{getFormErrorMessage(field.name)}
							</div>
						)}
					/>

					<Button
						label="Submit"
						className="p-button-sm"
						onClick={handleSubmit(onSubmit)}
						style={{ marginTop: "20px" }}
					/>
				</div>
			</div>
		</div>
	);
};

export default Authentication;
